import { PageActionType } from './page-action-type';
import { RedirectingAction } from '../interfaces';

export interface UpdatePageSuccessAction extends RedirectingAction {
  pageKey: string;
  type: PageActionType.UpdatePageSuccess;
}

export const updatePageSuccess = (
  pageKey: string,
  options: RedirectingAction = {},
): UpdatePageSuccessAction => ({
  ...options,
  pageKey,
  type: PageActionType.UpdatePageSuccess,
});
